document.addEventListener('DOMContentLoaded', function () {
  // Transição simples entre páginas (spinner ao clicar em links internos)
  var loader = document.createElement('div');
  loader.className = 'm-page-transition';
  loader.innerHTML = '<div class="m-blink"></div>';
  document.body.appendChild(loader);

  document.addEventListener('click', function (e) {
    var link = e.target.closest('a');
    if (!link || link.target === '_blank' || link.hasAttribute('data-no-transition')) return;
    var url = link.getAttribute('href');
    if (!url || url.startsWith('#') || url.startsWith('mailto:') || url.startsWith('tel:') || url.startsWith('https://wa.me')) return;
    if (link.hostname !== window.location.hostname) return;
    loader.classList.add('is-active');
  });

  // Fade-in de seções ao entrar na viewport
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.style.opacity = '1';
        entry.target.style.transform = 'none';
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1 });

  document.querySelectorAll('.m-section, .m-product-card').forEach(function (el) {
    el.style.opacity = '0';
    el.style.transform = 'translateY(16px)';
    el.style.transition = 'opacity .5s ease, transform .5s ease';
    observer.observe(el);
  });
});
